class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[drawer-close]').addEventListener('click', this.close.bind(this));
    this.section = this.closest('.shopify-section');
    this.overlay = this.querySelector('[drawer-close]');
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // if (Shopify.designMode) {
    //   this.section.addEventListener('shopify:section:select', () => this.openModal());
    //   this.section.addEventListener('shopify:section:deselect', () => this.close());
    //   this.section.addEventListener('shopify:section:unload', () => this.close());
    //   this.section.addEventListener('shopify:section:load', () => this.openModal());
    // }

    this.overlay.addEventListener('click', (e) => {
      this.close();
    })
    //this.setHeaderCartIconAccessibility();
  }
  connectedCallback() {
    this.cartTrigger = document.querySelector('[data-header-cart-trigger]');
    if (this.cartTrigger) {
      this.cartTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        window.setLastFocusedElement(this.cartTrigger);
        this.openModal();
      })
    }
  }
  openModal() {
    this.classList.add('drawer-open');
    this.setAttribute('drawer-open', '');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      trapFocus(this);
    }, 500);
  }
  /*
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  */
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.cart_drawer = document.querySelector('cart-drawer');
    this.quick_view = document.querySelector('drawer-section-view');
    if (this.cart_drawer) {
      this.updateCount();
      // const dataItemCountDrawer = this.cart_drawer.querySelector('[cart-count-drawer]');
      // if(dataItemCountDrawer){
      //     const headerCartBag = document.getElementById('main-cart-count-header-right');
      //     const getCount = parseInt(dataItemCountDrawer.innerHTML);
      //     if(headerCartBag){
      //       headerCartBag.innerText = dataItemCountDrawer.innerHTML;
      //       if(getCount == 0){
      //         headerCartBag.classList.add('hidden');
      //       }else{
      //         headerCartBag.classList.remove('hidden');
      //       }
      //     }
      // }
      setTimeout(() => {
        if (this.quick_view) {
          this.quick_view.classList.remove('drawer-open');
          setTimeout(() => {
            this.quick_view.removeAttribute('drawer-open');
          }, 300);
        }
        this.cart_drawer.classList.add('drawer-open');
        this.cart_drawer.setAttribute('drawer-open', '');
        document.body.classList.add('overflow-hidden');
      }, 200);
    }
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.cart_drawer;
        const focusElement = this.cart_drawer.querySelector('[drawer-close]');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }
  updateCount() {
    const dataItemCountDrawer = this.querySelector('[cart-count-drawer]');
    if (dataItemCountDrawer) {
      const headerCartBag = document.getElementById('main-cart-count-header-right');
      const getCount = parseInt(dataItemCountDrawer.innerHTML);
      if (headerCartBag) {
        headerCartBag.innerText = dataItemCountDrawer.innerHTML;
        if (getCount == 0) {
          headerCartBag.classList.add('hidden');
        } else {
          headerCartBag.classList.remove('hidden');
        }
      }
    }
  }
  close() {
    this.classList.remove('drawer-open');
    setTimeout(() => {
      this.removeAttribute('drawer-open');
      this.closeAllOtherCartContent();
      if(window.lastFocusedElement != null){
        window.returnFocusToLastElement();
      }else{
        if(this.cartTrigger){
        removeTrapFocus(this.cartTrigger);
        }
      }   
    }, 300);
    document.body.classList.remove('overflow-hidden');
  }
  closeAllOtherCartContent(){
    const drawerRecomdedContent = document.querySelector('cart-drawer-product-recommendations-content');
    if(drawerRecomdedContent && drawerRecomdedContent.classList.contains('active')){
      drawerRecomdedContent.classList.remove('active');
    }
    const allCartDialog = this.querySelectorAll('.cart-dialog');
    if(allCartDialog){
      allCartDialog.forEach((dialog) => {
        dialog.classList.remove('active');
      });
    }
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState, cartnotification) {
    this.querySelector('.drawer-inner').classList.contains('is-empty') &&
      this.querySelector('.drawer-inner').classList.remove('is-empty');

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    this.updateCount();
    setTimeout(() => {
      this.querySelector('[drawer-close]').addEventListener('click', this.close.bind(this));
      this.querySelector('[drawer-close-btn]').addEventListener('click', this.close.bind(this));
      if (!cartnotification) {
        this.open();
      }
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer', 
        section: 'cart-drawer',
        selector: '[drawer-body-inner]',
      },
      {
        id: 'CartDrawer', 
        section: 'cart-drawer',
        selector: '[cart-count-drawer]',
      },
      {  
        id: 'main-cart-shipping',
        section: document.getElementById('main-cart-shipping')?.dataset.id,
        selector: '[data-cart-shippingbar]',
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

class cartDrawerBtnClose extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button').addEventListener('click', this.close.bind(this));
  }
  close() {
    this.cart_drawer = document.querySelector('cart-drawer');
    this.cart_drawer.close();
    // this.cart_drawer.classList.remove('drawer-open');
    // setTimeout(() => {
    //   this.cart_drawer.removeAttribute('drawer-open');
    // }, 300);
    // document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('drawer-close-button', cartDrawerBtnClose);

if (!customElements.get('cart-drawer-product-recommendations')) {
  class ProductRecommendationsCart extends HTMLElement {
    constructor() {
      super();
      this.productId = this.getAttribute('product-recommendations-id');
    }
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = document.createElement('div');
          html.innerHTML = responseText;
          const escapedProductId = CSS.escape(parseInt(this.productId));
          const recommendations = html.querySelector(`[product-recommendations-id=${escapedProductId}]`);
          const recomendedItemsLength = html.querySelectorAll('[recommendation-drawer-item]');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          if (recomendedItemsLength.length > 0) {
            this.classList.remove('hidden');
          }
        })
        .catch((error) => {
          console.error('Error fetching recommendations:', error);
        });
    }
  }
  customElements.define('cart-drawer-product-recommendations', ProductRecommendationsCart);
}

class CartDrawerModalTrigger extends HTMLButtonElement {
  constructor() {
    super();
    this.parentElementWrapper = this.closest('[data-parent-wrapper]');
    this.dialog = this.parentElementWrapper.querySelector('.cart-dialog');
    this.dialogInner = this.dialog.querySelector('.cart-dialog-inner');
    if (this.parentElementWrapper) {
      this.addEventListener("click", this.open.bind(this));
      const closeBtn = this.parentElementWrapper.querySelector('[cart-dialog-close]');
      if (closeBtn) {
        closeBtn.addEventListener("click", this.close.bind(this));
      }
    }
    if (this.dialogInner) {
      this.dialogInner.addEventListener("focusout", this.handleFocusOut.bind(this));
    }
  }
  open() {
    this.parentElementWrapper.querySelector('.cart-dialog').classList.add('active');
  }
  close() {
    this.parentElementWrapper.querySelector('.cart-dialog').classList.remove('active');
  }
  handleFocusOut(event) { // new changes 10 nov
    requestAnimationFrame(() => {
      if (!this.dialogInner.contains(document.activeElement)) {
        this.close();
      }
    });
  }

}
customElements.define("cart-drawer-model-trigger", CartDrawerModalTrigger, { extends: "button", });

class cartOrderNoteSave extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.saveOrderNote.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
    this.setAttribute('tabindex', '0');
  }

  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.saveOrderNote();
    }
  }

  saveOrderNote() {
    const orderNoteText = document.querySelector('cart-notes-extra');
    const textAreaValue = orderNoteText.querySelector('textarea');
    const drawerClose = this.closest('[data-parent-wrapper]');
    const body = JSON.stringify({ note: textAreaValue.value });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) return;
        console.log('Order note updated successfully');
      })
      .catch(() => {
        console.log('Error updating order note');
      })
      .finally(() => {
        if (drawerClose) {
          drawerClose.querySelector('.cart-dialog').classList.remove('active');
        }
      });
  }
}

customElements.define('cart-note-save', cartOrderNoteSave);
 

class cartRecomendationToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.openProductRecomdentation.bind(this));
  }
  openProductRecomdentation() {
    const drawerRecomdedContent = document.querySelector('cart-drawer-product-recommendations-content');
    drawerRecomdedContent.classList.add('active');
    console.log('working');
    setTimeout(()=>{
      console.log('working focuse');
      trapFocus(drawerRecomdedContent);
    }, 500);
  }
}
customElements.define('recommendation-arrow', cartRecomendationToggle);

class cartRecomendationBack extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.backProductRecomdentation.bind(this));
  }
  backProductRecomdentation() {
    const drawerRecomdedContentTrigger = document.querySelector('recommendation-arrow');
    const drawerRecomdedContentTriggerButton = drawerRecomdedContentTrigger.querySelector('button');
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerRecomdedContent = document.querySelector('cart-drawer-product-recommendations-content');
    drawerRecomdedContent.classList.remove('active');
    console.log(cartDrawer);
    console.log(drawerRecomdedContentTrigger);
    setTimeout(()=>{
      // removeTrapFocus(drawerRecomdedContentTriggerButton);
      trapFocus(cartDrawer, drawerRecomdedContentTriggerButton);
    }, 500);
  }
}
customElements.define('drawer-back-button', cartRecomendationBack);



(function () {
  if (window.__ddsRecommendationsV2) return;
  window.__ddsRecommendationsV2 = true;

  function shopifyRoot() {
    return window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function money(cents) {
    var currency =
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
        ? Shopify.currency.active
        : 'INR';

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-IN',
        { style: 'currency', currency: currency }
      ).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function showStatus(track, text) {
    track.replaceChildren(element('p', 'cart-rec__status', text));
  }

  function updateButtons(root) {
    var track = root.querySelector('[data-rec-track]');
    if (!track) return;

    var canScroll =
      track.scrollWidth > track.clientWidth + 2 &&
      track.querySelectorAll('.cart-rec__card').length > 1;

    var prev = root.querySelector('[data-rec-prev]');
    var next = root.querySelector('[data-rec-next]');

    if (prev) prev.disabled = !canScroll;
    if (next) next.disabled = !canScroll;
  }

  function move(root, direction) {
    var track = root.querySelector('[data-rec-track]');
    if (!track) return;

    var cards = track.querySelectorAll('.cart-rec__card');
    if (!cards.length) return;

    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) return;

    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var distance = cards[0].getBoundingClientRect().width + gap;
    var target = track.scrollLeft + distance * direction;

    if (direction > 0 && target >= max - 3) target = 0;
    if (direction < 0 && target <= 3) target = max;

    track.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  }

  function makeCard(product) {
    var variants = product.variants || [];
    var variant = variants.find(function (v) {
      return v.available;
    });

    var card = element('article', 'cart-rec__card');
    var imageLink = element('a', 'cart-rec__image');
    imageLink.href = product.url || '#';

    var imageUrl = product.featured_image ||
      (product.images && product.images[0]) || '';

    if (imageUrl) {
      var img = element('img');
      img.src = imageUrl;
      img.alt = product.title || '';
      img.loading = 'lazy';
      imageLink.appendChild(img);
    }

    var details = element('div', 'cart-rec__details');
    var title = element('a', 'cart-rec__title', product.title || 'Product');
    title.href = product.url || '#';

    var price = element('div', 'cart-rec__price');
    price.appendChild(element('span', '', money(product.price)));

    if (
      product.compare_at_price &&
      Number(product.compare_at_price) > Number(product.price)
    ) {
      price.appendChild(
        element('s', 'cart-rec__compare', money(product.compare_at_price))
      );
    }

    details.appendChild(title);
    details.appendChild(price);

    if (product.available && variant) {
      var form = element('form', 'cart-rec__form');
      form.setAttribute('data-rec-add-form', '');

      var id = element('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = variant.id;

      var quantity = element('input');
      quantity.type = 'hidden';
      quantity.name = 'quantity';
      quantity.value = '1';

      var button = element('button', 'cart-rec__add');
      button.type = 'submit';

      var label = element('span', '', 'Add to cart');
      label.setAttribute('data-rec-button-label', '');
      button.appendChild(label);

      form.append(id, quantity, button);
      details.appendChild(form);
    } else {
      var soldOut = element('button', 'cart-rec__add', 'Sold out');
      soldOut.type = 'button';
      soldOut.disabled = true;
      details.appendChild(soldOut);
    }

    card.append(imageLink, details);
    return card;
  }

  async function loadProducts(root) {
    var track = root.querySelector('[data-rec-track]');
    if (!track) return;

    var productId = root.dataset.productId;
    var limit = Math.min(
      10,
      Math.max(1, Number(root.dataset.limit) || 8)
    );

    if (!productId) {
      showStatus(track, 'Product ID is missing.');
      console.error('[DDS recommendations] data-product-id is missing.');
      return;
    }

    showStatus(track, 'Loading recommendations…');

    var url = shopifyRoot() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=' + limit +
      '&intent=related';

    console.info('[DDS recommendations] Requesting:', url);

    var controller = new AbortController();
    var timeout = setTimeout(function () {
      controller.abort();
    }, 12000);

    try {
      var response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });

      if (!response.ok) {
        throw new Error('Shopify returned HTTP ' + response.status);
      }

      var data = await response.json();
      var products = data.products || [];

      console.info('[DDS recommendations] Products returned:', products.length);

      if (!products.length) {
        showStatus(
          track,
          'No recommendations available for this product yet.'
        );
        return;
      }

      track.replaceChildren();

      products.forEach(function (product) {
        track.appendChild(makeCard(product));
      });

      updateButtons(root);
      requestAnimationFrame(function () {
        updateButtons(root);
      });

    } catch (error) {
      console.error('[DDS recommendations] Loading failed:', error);

      showStatus(
        track,
        error.name === 'AbortError'
          ? 'Recommendations timed out. Please refresh and try again.'
          : 'Could not load recommendations. Check the browser console.'
      );
    } finally {
      clearTimeout(timeout);
    }
  }

  function init(root) {
    if (root.dataset.ddsV2Initialized === 'true') return;
    root.dataset.ddsV2Initialized = 'true';

    loadProducts(root);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rec-prev], [data-rec-next]');
    if (!button) return;

    var root = button.closest('[data-cart-rec]');
    if (!root) return;

    event.preventDefault();
    move(root, button.hasAttribute('data-rec-next') ? 1 : -1);
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-rec-add-form]');
    if (!form) return;

    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';

    var root = form.closest('[data-cart-rec]');
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-rec-button-label]');
    var message = root && root.querySelector('[data-rec-message]');
    var original = label ? label.textContent : 'Add to cart';

    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';
    if (message) message.textContent = '';

    try {
      var response = await fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(new FormData(form).get('id')),
          quantity: Number(new FormData(form).get('quantity')) || 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Add to cart failed.');
      }

      var drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(result);
        if (typeof drawer.open === 'function') drawer.open();
      } else if (message) {
        message.textContent = 'Product added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { item: result }
        }));
      }

      if (label) label.textContent = 'Added!';
      setTimeout(function () {
        if (label) label.textContent = original;
      }, 1500);

    } catch (error) {
      console.error('[DDS recommendations] Add to cart failed:', error);
      if (label) label.textContent = 'Try again';
      if (message) message.textContent = error.message;
    } finally {
      if (button) button.disabled = false;
      form.dataset.submitting = 'false';
    }
  });

  function scan() {
    document.querySelectorAll('[data-cart-rec]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);

  if ('MutationObserver' in window && document.body) {
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
